var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ftw-system-bar',{attrs:{"messages":_vm.systemMessages,"item-icon":"type.icon"},on:{"dismiss":_vm.dismissMessage}})
}
var staticRenderFns = []

export { render, staticRenderFns }